<!-- review -->
<div class="row mt-5">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center border-bottom mb-4 pb-2">
      <h5 class="aa-heading-title fw-bold  mb-0">
        <i class="bi bi-people me-2"></i>{{'Member Review' | translate}}
      </h5>
      <button type="button" *ngIf="addStatus && USERID" data-bs-toggle="modal" data-bs-target="#addModal"
        class="btn btn-primary btn-sm rounded-pill px-3 shadow-sm hover-elevate-up d-flex align-items-center gap-2">
        <i class="bi bi-plus-lg"></i> {{ "Add review" | translate }}
      </button>
    </div>

    <ngx-spinner bdOpacity="0.9" bdColor="" size="default" color="#581f87" type="ball-pulse-sync" [fullScreen]="false">
    </ngx-spinner>

    <div *ngIf="reviewData.length > 0; else noReviews">
      <div class="d-flex flex-column gap-3">
        <div class="card border-0 shadow-sm rounded-4 p-3 bg-white" *ngFor="let item of reviewData">
          <div class="card-body p-0">
            <div class="d-flex gap-3">
              <div class="flex-shrink-0">
                <div class="rounded-circle bg-info-subtle text-info d-flex align-items-center justify-content-center"
                  style="width: 40px; height: 40px;">
                  <i class="bi bi-person fs-5"></i>
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="mb-2 text-dark review-detail-content" [innerHTML]="item.REVIEWDETAIL"></div>
                <div
                  class="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3 pt-3 border-top border-light-subtle">
                  <div class="text-secondary small d-flex align-items-center gap-2">
                    <span class="fw-semibold">{{ item.REVIEWBy }}</span>
                    <span class="text-body-tertiary">•</span>
                    <span>{{ item.REVIEWDATE }}</span>
                  </div>

                  <div class="d-flex gap-2" *ngIf="USERID == item.USERID">
                    <button (click)="showEditModal(item)"
                      class="btn btn-light btn-light-walai border rounded-pill text-dark btn-sm  px-3 d-flex align-items-center gap-2 hover-elevate-up">
                      <i class="bi bi-pencil-square"></i> {{ 'Edit' | translate }}
                    </button>
                    <button (click)="deleteReview(item.REVIEWID)"
                      class="btn btn-outline-danger btn-sm rounded-pill px-3 d-flex align-items-center gap-2 hover-elevate-up">
                      <i class="bi bi-trash"></i> {{ 'Delete' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noReviews>
      <div class="text-center py-4 bg-light rounded-4 border border-dashed">
        <i class="bi bi-people text-secondary opacity-25 fs-1 mb-2 d-block"></i>
        <p class="text-muted mb-0">{{ 'NoMemberReviewsYet' | translate }}</p>
        <button *ngIf="addStatus && USERID" data-bs-toggle="modal" data-bs-target="#addModal"
          class="btn btn-sm btn-link text-decoration-none mt-1">
          {{ 'BeTheFirstToWriteOne' | translate }}
        </button>
      </div>
    </ng-template>

  </div>
</div>

<!-- Modal Add -->
<div class="modal fade" id="addModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content border-0 shadow rounded-4">
      <div class="modal-header border-0 pb-0 pt-4 px-4">
        <h5 class="modal-title fw-bold text-primary" id="exampleModalLabel">
          {{ "Add review" | translate }}
        </h5>
        <button type="button" class="btn-close bg-light rounded-circle p-2" data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body px-4 py-3">
        <form class="example-form" [formGroup]="addFG">
          <!-- <ckeditor [editor]="Editor" formControlName="value"></ckeditor> -->
          <angular-editor [config]="editorConfig" formControlName="value"></angular-editor>

          <div class="d-flex justify-content-end gap-2 mt-4">
            <button (click)="Save('p')" [disabled]="!addFG.valid"
              class="btn btn-primary rounded-pill px-4 hover-elevate-up" type="submit">
              {{ 'PublishReview' | translate }}
            </button>
            <!-- <button (click)="Save('d')" [disabled]="!addFG.valid" class="btn btn-outline-primary rounded-pill px-4" type="submit">Save review as Draft </button> -->
          </div>
        </form>
      </div>
      <div class="modal-footer border-0">
      </div>
    </div>
  </div>
</div>

<!-- Modal Edit -->
<div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content border-0 shadow rounded-4">
      <div class="modal-header border-0 pb-0 pt-4 px-4">
        <h5 class="modal-title fw-bold text-primary" id="exampleModalLabel">
          {{ "Edit review" | translate }}
        </h5>
        <button type="button" class="btn-close bg-light rounded-circle p-2" data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body px-4 py-3">
        <form class="example-form" [formGroup]="editFG">
          <!-- <ckeditor [editor]="Editor" formControlName="value"></ckeditor> -->
          <angular-editor [config]="editorConfig" formControlName="value"></angular-editor>

          <div class="d-flex justify-content-end gap-2 mt-4">
            <button (click)="edit('p')" [disabled]="!editFG.valid"
              class="btn btn-primary rounded-pill px-4 hover-elevate-up" type="submit">
              {{ 'PublishReview' | translate }}
            </button>
            <!-- <button (click)="edit('d')" [disabled]="!editFG.valid" class="btn btn-outline-primary rounded-pill px-4" type="submit">Save review as Draft </button> -->
          </div>
        </form>
      </div>
      <div class="modal-footer border-0">
      </div>
    </div>
  </div>
</div>